var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEnergyGr = function SvgEnergyGr(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 296,
    height: 87,
    viewBox: "0 0 296 87",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452",
    transform: "translate(-257 -737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1866",
    "data-name": "Rectangle 1866",
    d: "M5,0h5a5,5,0,0,1,5,5V67a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(310 757)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1878",
    "data-name": "Rectangle 1878",
    d: "M5,0h5a5,5,0,0,1,5,5V61a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(260 763)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1873",
    "data-name": "Rectangle 1873",
    d: "M5,0h5a5,5,0,0,1,5,5V65a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(410 759)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1869",
    "data-name": "Rectangle 1869",
    d: "M5,0h5a5,5,0,0,1,5,5V75a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(360 749)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1871",
    "data-name": "Rectangle 1871",
    d: "M5,0h5a5,5,0,0,1,5,5V72a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(460 752)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1875",
    "data-name": "Rectangle 1875",
    d: "M5,0h5a5,5,0,0,1,5,5V62a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(535 762)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1867",
    "data-name": "Rectangle 1867",
    d: "M5,0h5a5,5,0,0,1,5,5V62a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(335 762)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1872",
    "data-name": "Rectangle 1872",
    d: "M5,0h5a5,5,0,0,1,5,5V73a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(435 751)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1868",
    "data-name": "Rectangle 1868",
    d: "M5,0h5a5,5,0,0,1,5,5V67a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(385 757)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1870",
    "data-name": "Rectangle 1870",
    d: "M5,0h5a5,5,0,0,1,5,5V62a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(485 762)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1880",
    "data-name": "Rectangle 1880",
    width: 96,
    height: 2,
    rx: 1,
    transform: "translate(357 753)",
    fill: "#25556e",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1881",
    "data-name": "Rectangle 1881",
    width: 96,
    height: 2,
    rx: 1,
    transform: "translate(457 759)",
    fill: "#25556e",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1879",
    "data-name": "Rectangle 1879",
    width: 96,
    height: 2,
    rx: 1,
    transform: "translate(257 761)",
    fill: "#25556e",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    id: "_13_134_kWh",
    "data-name": "13,134 kWh",
    transform: "translate(257 755)",
    fill: "#25556e",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "13,134 kWh")), /*#__PURE__*/React.createElement("text", {
    id: "_13_264_kWh_wk",
    "data-name": "13,264 kWh/wk",
    transform: "translate(357 747)",
    fill: "#25556e",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "13,264 kWh/wk")), /*#__PURE__*/React.createElement("text", {
    id: "_13_184_kWh_wk",
    "data-name": "13,184 kWh/wk",
    transform: "translate(457 753)",
    fill: "#25556e",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "13,184 kWh/wk")), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1877",
    "data-name": "Rectangle 1877",
    d: "M5,0h5a5,5,0,0,1,5,5V56a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(285 768)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1876",
    "data-name": "Rectangle 1876",
    d: "M5,0h5a5,5,0,0,1,5,5V54a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(510 770)",
    fill: "#ddd"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEnergyGr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/energy_gr.367169aeb41ee5650048888c5df3df3a.svg";